import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import StepOnboardingModal from "./ProjectOnboarding/StepOnbordingModal";
import CreateProjectComponentModal from "components/ProjectAndSearch/CreateProjectComponentModal";
import CreateProjectByATS from "components/ProjectAndSearch/CreateProjectByATS";
import { useAppSelector } from "hooks/reduxHooks";
import AddCandidateCriteria from "components/HRFlow/steps/Step4Candidates/AddCandidateCriteria";

interface StepOnboardingModalProps {
    isVisible: boolean;
    onClose: () => void;
    setRefresh: React.Dispatch<React.SetStateAction<number>>;
}

const ProjectRootSelectionModal: React.FC<StepOnboardingModalProps> = ({ isVisible, onClose, setRefresh }) => {
    const [currentStep, setCurrentStep] = useState(0);

    const userData = useAppSelector((state) => state.auth.user);
    const isGreenHouse = userData?.plugins?.some((plugin: any) => plugin.name === "Greenhouse-Mckinney");
    const isLever = userData?.plugins?.some((plugin: any) => plugin.name === "Lever-SS");

    const rootSteps = [
        {
            title: "Import files to create project",
            content: <StepOnboardingModal isVisible={isVisible} onClose={onClose} setRefresh={setRefresh} />,
        },
        {
            title: "Enter details to create project",
            content: <CreateProjectComponentModal onClose={onClose} setRefresh={setRefresh} />,
        },
        ...(isGreenHouse || isLever
            ? [{
                title: "Import project from ATS",
                content: <CreateProjectByATS onClose={onClose} setRefresh={setRefresh} />,
            }]
            : [])
    ];

    const handleStepClick = (index: number) => {
        setCurrentStep(index);
    };

    return (
        <Modal
            // title={
            //     // <div style={{ display: "flex", alignItems: "center", marginBottom: "2%", padding: "1%" }}>
            //     //     <div style={{ display: "flex", alignItems: "center" }}>
            //     //         <svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
            //     //             <g filter="url(#filter2_dii_12621_39177)">
            //     //                 <rect x="0" y="0" width="48" height="48" rx="8" fill="#F4EBFF" stroke="#E4E7EC" />
            //     //                 <path
            //     //                     d="M24 9.5L22.884 7.269C22.563 6.627 22.403 6.306 22.163 6.071C21.952 5.864 21.696 5.706 21.416 5.609C21.099 5.5 20.74 5.5 20.022 5.5H16.2C15.08 5.5 14.52 5.5 14.092 5.718C13.716 5.91 13.41 6.216 13.218 6.592C13 7.02 13 7.58 13 8.7V9.5M13 9.5H28.2C29.88 9.5 30.72 9.5 31.362 9.827C31.926 10.115 32.385 10.574 32.673 11.138C33 11.78 33 12.62 33 14.3V18.7C33 20.38 33 21.22 32.673 21.862C32.385 22.426 31.926 22.885 31.362 23.173C30.72 23.5 29.88 23.5 28.2 23.5H17.8C16.12 23.5 15.28 23.5 14.638 23.173C14.074 22.885 13.615 22.426 13.327 21.862C13 21.22 13 20.38 13 18.7V9.5Z"
            //     //                     fill="none"
            //     //                     stroke="#344054"
            //     //                     strokeWidth="2"
            //     //                     strokeLinecap="round"
            //     //                     strokeLinejoin="round"
            //     //                     transform="translate(0, 8)"
            //     //                 />
            //     //             </g>

            //     //             <defs>
            //     //                 <filter id="filter2_dii_12621_39177" x="-10" y="-10" width="68" height="68" filterUnits="userSpaceOnUse">
            //     //                     <feOffset dx="2" dy="2" result="offset" />
            //     //                     <feGaussianBlur stdDeviation="4" result="blur" />
            //     //                     <feBlend in="SourceGraphic" in2="blur" mode="normal" />
            //     //                 </filter>
            //     //             </defs>
            //     //         </svg>
            //     //     </div>
            //     //     <div style={{ marginLeft: "16px" }}>
            //     //         <h2 style={{ fontSize: "20px", margin: 0 }}>
            //     //             Create a Project <span style={{ color: "#845dda" }}> / Step {currentStep + 1}</span>
            //     //         </h2>
            //     //         <p style={{ color: "#888" }}>Create a project to be able to use AI assistant</p>
            //     //     </div>
            //     // </div>
            // }
            visible={isVisible}
            onCancel={onClose}
            footer={null}
            width={900}
        >
            <div style={{ display: "flex", justifyContent: "space-between", borderBottom: "2px solid #e8e8e8", marginBottom: "20px" }}>
                {rootSteps.map((step, index) => (
                    <div
                        key={index}
                        onClick={() => handleStepClick(index)}
                        style={{
                            flex: 1,
                            textAlign: "center",
                            padding: "10px 20px",
                            cursor: "pointer",
                            pointerEvents: "auto",
                            fontWeight: "bold",
                            color: currentStep === index ? "#845dda" : "#000",
                            borderBottom: currentStep === index ? "2px solid #845dda" : "2px solid transparent",
                        }}
                    >
                        {step.title}
                    </div>
                ))}
            </div>
            <div>{rootSteps[currentStep].content}</div>
            {/* {(currentStep === 0 || currentStep === 1) && } */}
        </Modal>
    );
};

export default ProjectRootSelectionModal;
